import { useFormikContext } from 'formik';
import { useEffect } from 'react';

export function ScrollToError() {
    const formik = useFormikContext();
    const submitCount = formik?.submitCount;
    const errors = formik?.errors;

    useEffect(() => {
        if (!submitCount || !errors || !Object.keys(errors).length) return;

        const firstErrorField = Object.keys(errors)[0];
        const field = document.querySelector(`[name="${firstErrorField}"]`);
        const fallback = document.querySelector('[data-error="true"], .Mui-error');
        const errorElement = field || fallback;

        if (!errorElement) return;

        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (typeof errorElement.focus === 'function') {
            errorElement.focus({ preventScroll: true });
        }
    }, [errors, submitCount]);
    return null;
}
